import React from 'react';
import { useIntl } from 'react-intl';
import { Form, Input as AntDInput } from 'antd';
import { constructValidationRules } from './validations';
import './styles.scss';

const Input = ({error, className, name, label, validation = {}, customRules, validateTrigger, customLayout, style, tooltip, noMargin = false, ...props}: any) => {
  const intl = useIntl();

  let labelCol: any = { span: 8 };
  let wrapperCol: any = { span: 6 };
  let wrapperClassName = ''

  if (customLayout) {
    if (typeof customLayout === 'object') {
      labelCol = customLayout.labelCol || undefined;
      wrapperCol = customLayout.wrapperCol || undefined;
    } else {
      labelCol = undefined;
      wrapperCol = undefined;
    }
  }

  if (noMargin) {
    wrapperClassName = 'm-0 '
  }

  return (
    <Form.Item 
      className={wrapperClassName}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      name={name}
      label={label}
      rules={customRules || constructValidationRules(validation, intl)}
      validateTrigger={validateTrigger}
      style={style}
    >
      <AntDInput maxLength={255} autoComplete="off" {...props} className={`default-input-field ${className || ''}`} />
    </Form.Item>
  );
}

export default Input;
